module.exports = __webpack_public_path__ + "static/media/markerP.12b374da.svg";